import { render, staticRenderFns } from "./IndexHappening.vue?vue&type=template&id=363dc2f4&scoped=true&"
import script from "./IndexHappening.vue?vue&type=script&lang=js&"
export * from "./IndexHappening.vue?vue&type=script&lang=js&"
import style0 from "./IndexHappening.vue?vue&type=style&index=0&id=363dc2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363dc2f4",
  null
  
)

export default component.exports